import { useEffect } from "react";

export default function StructuredData({ id, data }) {
  useEffect(() => {
    if (!id || !data || typeof document === "undefined") return undefined;

    const script =
      document.getElementById(id) || document.createElement("script");

    script.id = id;
    script.type = "application/ld+json";
    script.textContent = JSON.stringify(data);

    if (!script.parentNode) {
      document.head.appendChild(script);
    }

    return () => {
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, [data, id]);

  return null;
}
